"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../helpers");
var ImageSize;
(function (ImageSize) {
    ImageSize["Original"] = "original";
})(ImageSize = exports.ImageSize || (exports.ImageSize = {}));
function getImageUrl(dict, key, defaultKey) {
    if (defaultKey === void 0) { defaultKey = ImageSize.Original; }
    var files = helpers_1.safeParseJSON(dict);
    return files[key] ? files[key].url : files[defaultKey] ? files[defaultKey].url : "";
}
exports.getImageUrl = getImageUrl;
//# sourceMappingURL=file.js.map